import { FieldArray, useFormikContext } from 'formik';
import Accordion from '../../../../components/Accordion/Accordion';
import Button from '../../../../components/Button/Button';
import '../BackofficeMaterial.scss';
import { IFormikBOM } from '../IBackofficeMaterial';
import { useTranslation } from 'react-i18next';
interface IFormikImagesProps {}

export const FormikImages = (props: IFormikImagesProps) => {
    const { values, setFieldValue } = useFormikContext<IFormikBOM>();
    const { t } = useTranslation();

    return (
        <div className='w-25 d-flex flex-column gap-2'>
            <label className='py-3'>{t('bo_material_titles_p')}</label>
            <FieldArray
                name='images'
                render={arrayHelpers => (
                    <>
                        {values.images.map((image, index) => {
                            let imageUrl = image.imageUrl;
                            return (
                                <Accordion title={`Picture${index}`} key={imageUrl + index}>
                                    <div className='d-flex justify-content-around pictureBox'>
                                        <div className='d-flex flex-column'>
                                            <label htmlFor={`file${index}`} className='btn-color-inverted' style={{ cursor: 'pointer' }}>
                                                <i className='fa-solid fa-arrow-up-from-bracket' />
                                                <input
                                                    className='d-none'
                                                    id={`file${index}`}
                                                    name='file'
                                                    onChange={e => {
                                                        if (e?.target?.files && e?.target?.files[0]) {
                                                            setFieldValue(`images[${index}].imageUrl`, URL.createObjectURL(e!.target.files![0]));
                                                            setFieldValue(`images[${index}].actualFile`, e!.target.files![0]);
                                                        }
                                                    }}
                                                    type='file'
                                                    accept='image/*'
                                                />
                                            </label>
                                            {imageUrl && (
                                                <Button classNameBtn='btn-color-icon-delete' onClick={() => arrayHelpers.remove(index)}>
                                                    <i className='fa-solid fa-trash' />
                                                </Button>
                                            )}
                                        </div>
                                        {imageUrl && <img src={imageUrl} alt='preview image' className='w-75 h-75' />}
                                    </div>
                                </Accordion>
                            );
                        })}
                        <Button className='d-flex justify-content-end pt-2' classNameBtn='btn-color-inverted' onClick={() => arrayHelpers.push({ imageUrl: '', actualFile: undefined })}>
                            <i className='fa-solid fa-plus' />
                        </Button>
                    </>
                )}
            />
        </div>
    );
};
